import { Store } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducer';
import { RootState } from '../typings';

const createStore: (initialState?: RootState) => {
	store: Store;
} = initialState => {
	const store = configureStore({ reducer: rootReducer, preloadedState: initialState });
	return { store };
};

export default createStore;
